<template>
  <svg
    :viewBox="`0 0 ${CASE_MATERIAL_IMAGE_SIZE} ${CASE_MATERIAL_IMAGE_SIZE}`"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask :id="maskId">
      <image
        :height="CASE_MATERIAL_IMAGE_SIZE"
        :href="data.mask"
        :width="CASE_MATERIAL_IMAGE_SIZE"
        :x="0"
        :y="0"
      />
    </mask>
    <image
      v-for="(url, i) in data.preDesignLayers"
      :key="i"
      :height="CASE_MATERIAL_IMAGE_SIZE"
      :href="url"
      :width="CASE_MATERIAL_IMAGE_SIZE"
    />
    <image
      :height="data.design.rect.height"
      :href="data.design.url"
      :mask="`url('#${maskId}')`"
      :width="data.design.rect.width"
      :x="data.design.rect.x"
      :y="data.design.rect.y"
    />
    <image
      v-for="(url, i) in data.postDesignLayers"
      :key="i"
      :height="CASE_MATERIAL_IMAGE_SIZE"
      :href="url"
      :width="CASE_MATERIAL_IMAGE_SIZE"
    />
  </svg>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid'

import { CASE_MATERIAL_IMAGE_SIZE } from '../designArea/utils'
import { type MultiLayerPreviewData } from './MultiLayerPreviewData'

defineProps<{
  readonly data: MultiLayerPreviewData
}>()

const maskId = uuidv4()
</script>
